import React from 'react';

import {Link} from '../../../lib/routes';
import type {WikiArticleFragment} from '../../../generated/types';
import {WIKI_TYPES, isWikiType} from '../infobox';

import css from './wiki-view.module.css';

function plural(type: string): string {
	return isWikiType(type) ? WIKI_TYPES[type].plural : WIKI_TYPES.concept.plural;
}

export const WikiNavboxes: React.FC<{article: WikiArticleFragment}> = ({article}) =>
	article.navboxes.length ? (
		<>
			{article.navboxes.map((navbox) => (
				<nav key={navbox.type} className={css.navbox} aria-label={plural(navbox.type)}>
					<div className={css.navboxTitle}>
						{plural(navbox.type)}
						{navbox.scope && (
							<>
								{' — '}
								<Link route="wikiArticle" params={{id: navbox.scope.id}}>
									{navbox.scope.title}
								</Link>
							</>
						)}
					</div>
					<div className={css.navboxList}>
						{navbox.articles.map((item, index) => (
							<React.Fragment key={item.id}>
								{index > 0 && ' · '}
								{item.id === article.id ? (
									<strong aria-current="page">{item.title}</strong>
								) : (
									<Link route="wikiArticle" params={{id: item.id}}>
										{item.title}
									</Link>
								)}
							</React.Fragment>
						))}
					</div>
				</nav>
			))}
		</>
	) : null;
